export default {
  title: {
    id: 'bo_sellers-orders-components-orders_table-actions-expected_dispatch_date',
    defaultMessage: 'Expected drop off date',
  },
  overdue: {
    id: 'bo_sellers-orders-components-orders_table-actions-overdue',
    defaultMessage: 'Overdue',
  },
  today: {
    id: 'bo_sellers-orders-components-orders_table-actions-today',
    defaultMessage: 'Today',
  },
  tomorrow: {
    id: 'bo_sellers-orders-components-orders_table-actions-tomorrow',
    defaultMessage: 'Tomorrow',
  },
} as const
